import React, { useState } from "react";
import { BreadcrumbItem, Card, CardBody, Container } from "reactstrap";
import { CupboardList } from "components/cupboard/list";
import { HelpButton, HelpDialog } from "components/chat/help";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Cupboard</BreadcrumbItem>;

// The food the organization has in to eat. The chat reads it to say what to
// eat next, and changes it when told ("we're out of milk"); this is where it
// is read and corrected by hand. The chat's Cupboard tab is the same list.
export const Content = () => {
  const [help, setHelp] = useState(false);
  return (
    <Container className="mt-4" style={{ maxWidth: 760 }}>
      <h4 className="m-0">Cupboard</h4>
      <p className="text-muted small mt-1 mb-0">
        What you have in. The chat suggests meals from it. <HelpButton onClick={() => setHelp(true)} label={"More"} />
      </p>
      <HelpDialog isOpen={help} toggle={() => setHelp((open) => !open)} />
      <Card className="mt-3">
        <CardBody>
          <CupboardList />
        </CardBody>
      </Card>
    </Container>
  );
};
